export default {"src":"/_next/static/media/forbes_logo_black.8abeac8d.svg","height":25,"width":96,"blurWidth":0,"blurHeight":0};